import { onLoginAs } from "redux/reducers/user";

export const OnLogin = (_this, items) => {
  return _this.props.dispatch(onLoginAs(items[0].id));
}